import { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import ContactModal from "../components/ContactModal";
import useClickAway from "@/hooks/use-click-away";
import logo from "@/assets/images/logo.png";
import "./ConsoleHeader.scss";

const DOCS_URL = "/api-docs/index.html";

/**
 * 顶部 Header（Pricing 营销页与控制台共用）：
 *   左侧 —— 主站 Logo + 文字（点击回 Pricing）
 *   右侧 —— 导航（Pricing / Docs / Contact） + 登录信息
 *           已登录展示邮箱下拉（Dashboard / Sign out），未登录展示 Sign in
 */
const ConsoleHeader = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user, signOut } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);

  useClickAway(menuRef, () => setMenuOpen(false));

  return (
    <header className="cs-header">
      {/* 左：Logo（点击回 Pricing） */}
      <button
        type="button"
        className="cs-header__brand"
        onClick={() => navigate("/pricing")}
      >
        <img className="cs-header__logo-img" src={logo} alt="CloudStore AI" />
        <span className="cs-header__logo-text">CloudStore AI</span>
      </button>

      {/* 右：导航 + 登录信息 */}
      <div className="cs-header__nav">
        <Link className="cs-header__link" to="/pricing">
          Pricing
        </Link>
        <a
          className="cs-header__link"
          href={DOCS_URL}
          target="_blank"
          rel="noreferrer"
        >
          Docs
        </a>
        <button
          type="button"
          className="cs-header__link"
          onClick={() => setContactOpen(true)}
        >
          Contact
        </button>

        {isAuthenticated ? (
          <div className="cs-header__user" ref={menuRef}>
            <button
              type="button"
              className="cs-header__user-btn"
              onClick={() => setMenuOpen((v) => !v)}
            >
              {user?.email || "Account"}
              <span className="cs-header__caret">▾</span>
            </button>

            {menuOpen && (
              <div className="cs-header__menu">
                <button
                  type="button"
                  className="cs-header__menu-item"
                  onClick={() => {
                    setMenuOpen(false);
                    navigate("/dashboard");
                  }}
                >
                  Dashboard
                </button>
                <button
                  type="button"
                  className="cs-header__menu-item"
                  onClick={() => {
                    setMenuOpen(false);
                    signOut();
                  }}
                >
                  Sign out
                </button>
              </div>
            )}
          </div>
        ) : (
          <button
            type="button"
            className="cs-header__link"
            onClick={() => navigate("/dashboard")}
          >
            Sign in
          </button>
        )}
      </div>

      {/* Contact Us 弹窗 */}
      <ContactModal open={contactOpen} onClose={() => setContactOpen(false)} />
    </header>
  );
};

export default ConsoleHeader;
